import { Component } from '@angular/core';

@Component({
  selector: 'app-investment-zones',
  templateUrl: './investment-zones.component.html',
  styleUrl: './investment-zones.component.scss'
})
export class InvestmentZonesComponent {

}
